export const generateFileFrom = (fileName: string, data: string | string[]) => {
	const value = Array.isArray(data) ? data.join('\n') : data;
	const element = document.createElement('a');
	const file = new Blob([value], {
		type: 'text/csv',
	});
	element.href = URL.createObjectURL(file);
	element.download = fileName;
	document.body.appendChild(element); // Required for this to work in FireFox
	element.click();
};
